import React from "react";

export const ColoredXMLFileIcon = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 4C4 1.79086 5.79086 0 8 0H24L36 12V36C36 38.2091 34.2091 40 32 40H8C5.79086 40 4 38.2091 4 36V4Z"
        fill="#DC6803"
      />
      <path opacity="0.3" d="M24 0L36 12H28C25.7909 12 24 10.2091 24 8V0Z" fill="white" />
      <path
        d="M11.9788 25.4545L13.2987 27.6854H13.3499L14.6762 25.4545H16.2391L14.2416 28.7273L16.2838 32H14.6922L13.3499 29.766H13.2987L11.9564 32H10.3712L12.4198 28.7273L10.4095 25.4545H11.9788ZM17.1148 25.4545H18.8215L20.624 29.8523H20.7007L22.5033 25.4545H24.21V32H22.8676V27.7397H22.8133L21.1194 31.968H20.2053L18.5115 27.7237H18.4571V32H17.1148V25.4545ZM25.3501 32V25.4545H26.734V30.859H29.5401V32H25.3501Z"
        fill="white"
      />
    </svg>
  );
};
